const SET_UTM_SOURCE_INITIATED = 'SET_UTM_SOURCE_INITIATED';
const SET_UTM_SOURCE_SUCCEEDED = 'SET_UTM_SOURCE_SUCCEEDED';
const SET_UTM_SOURCE_FAILED = 'SET_UTM_SOURCE_FAILED';

export default {
  SET_UTM_SOURCE_INITIATED,
  SET_UTM_SOURCE_FAILED,
  SET_UTM_SOURCE_SUCCEEDED,
};
